export const locale = {
  'INPROGRESS': {
    'TITLE': 'Заказы в процессе',
    'WITHOUT_APP': 'Без приложения',
  },
};
